import { useQuery } from '@tanstack/react-query';

import { Configuration, DirectIndex, UniverseApi } from '@/cip/_openapi/portfolio-optimizer';
import { defaultApiConfig } from '@/cip/api/defaultApiConfig';

const universeApi = new UniverseApi(new Configuration(defaultApiConfig));
const directIndexes = Object.values(DirectIndex);

/** Membership across all sampled NDVR 1500 strategies, not the full enriched security catalog. */
export const useSampledUniverse = (enabled: boolean) =>
    useQuery({
        queryKey: ['universe', 'sampled', directIndexes],
        queryFn: async ({ signal }) => {
            const universes = await Promise.all(
                directIndexes.map((directIndex) => universeApi.getSampledUniverse({ directIndex }, { signal })),
            );
            return new Set(universes.flat());
        },
        enabled,
        staleTime: 5 * 60 * 1000,
        throwOnError: false,
    });
